import { Outlet } from 'react-router-dom';
import { useIsLandscape } from '../responsiveDesign/responsiveDesign';

/**
 * Layout for public routes (e.g., legal documents).
 * No TopBar; applies the standard centered max-width on landscape viewports
 * so the content does not stretch edge-to-edge on wide desktop windows.
 */
export const PublicRouteContainer = () => {
  const isLandscape = useIsLandscape();

  return (
    <main>
      {/* Full width on portrait, centered with max-width on landscape */}
      <div className={isLandscape
        ? "sm:mx-auto sm:max-w-[85%] md:max-w-[85%] lg:max-w-[85%] xl:max-w-[85%] 2xl:max-w-[85%]"
        : "w-full"}
      >
        {/* Content without TopBar */}
        <Outlet />
      </div>
    </main>
  );
};
